export const BL_STATUS_OPTIONS = [
    "Pending",
    "Released"
    ]
export const BL_RELEASE_TYPE = [
    {value: 'rfs', text: 'Recieved For Shipment'},
    {value: 'sob', text: 'Shipped Onboard'}
]